/**
 * nav
 */

import $ from 'jquery';

// Bootstrap CSS components this pattern uses
import '../../00-protons/printing/libs/bootstrap-components/nav.scss';
import '../../00-protons/printing/libs/bootstrap-components/dropdown.scss';

// Bootstrap JS
// eslint-disable-next-line no-unused-vars
import Tab from 'bootstrap/js/src/tab';
// eslint-disable-next-line no-unused-vars
import Dropdown from 'bootstrap/js/src/dropdown';

// Module styles
import './_nav.scss';

// Import SCSS Data
import scssVariables from '../../../_data/scssVariables.json';

// Get breakpoints from JSON
const scssBreakpoints = scssVariables.scssBreakpoints;

/**
 * Convert em value to px (assumes 16px base font size)
 *
 * @param {string|number} emValue - Value in em (e.g., "48em") or 0
 * @return {number} Value in pixels
 */
const emToPx = (emValue) => {
  if (typeof emValue === 'number') return emValue;
  return parseFloat(emValue) * 16;
};

/**
 * Get the desktop breakpoint in px for a navbar based on its navbar-expand-* class
 *
 * @param {Element} navbar - The navbar element
 * @return {number} Breakpoint in pixels, or 0 if not found
 */
const getNavbarBreakpoint = (navbar) => {
  if (!navbar) return 0;

  const expandClass = [...navbar.classList].find(cls => cls.startsWith('navbar-expand-'));
  if (!expandClass) return 0;

  const breakpointSuffix = expandClass.replace('navbar-expand-', '');
  const emValue = scssBreakpoints[breakpointSuffix];

  return emValue ? emToPx(emValue) : 0;
};

/**
 * Check if we're at or above the navbar's desktop breakpoint
 *
 * @param {Element} navbar - The navbar element
 * @return {boolean} True if at desktop breakpoint or above
 */
const isDesktopBreakpoint = (navbar) => {
  const breakpointPx = getNavbarBreakpoint(navbar);
  return window.innerWidth >= breakpointPx;
};

export const name = 'nav';

const navEnable = () => {
  // Find our component within the DOM
  const $nav = $('.nav');

  // Bail if component does not exist
  if (!$nav.length) {
    return;
  }

  // An example of what could be done with this component
  $nav.map((i, nav)=> {
    $(nav).addClass('js-nav-exists');
    return $nav;
  });
};

/**
 * Add nav-open class to body when dropdown is open
 * Only applies to navbars with .has-overlay class and only on desktop
 */
const handleNavOpenClass = () => {
  const body = document.body;
  const navbars = document.querySelectorAll('.navbar-nav');

  navbars.forEach(navbarNav => {
    // Only navbars with .has-overlay should trigger body overlay classes
    const hasOverlay = navbarNav.classList.contains('has-overlay');
    // Find parent .navbar element for breakpoint detection
    const navbar = navbarNav.closest('.navbar');

    // For hover dropdowns
    if (navbarNav.classList.contains('dropdown-hover')) {
      // Add nav-open on dropdown hover (only if overlay enabled and on desktop)
      navbarNav.addEventListener('mouseenter', (e) => {
        if (e.target.closest('.dropdown:not(.has-mega-menu)') && hasOverlay && isDesktopBreakpoint(navbar)) {
          body.classList.add('nav-open');
        }
      }, true);

      navbarNav.addEventListener('mouseleave', () => {
        // Only handle removal on desktop - mobile nav manages its own state
        if (!isDesktopBreakpoint(navbar)) {
          return;
        }
        // Check if any hover dropdown is still being hovered
        const hasHoveredDropdown = document.querySelector('.navbar-nav.dropdown-hover .dropdown:hover');
        // Check if any click dropdown is still open
        const hasOpenClickDropdown = document.querySelector('.navbar-nav:not(.dropdown-hover) .dropdown:not(.has-mega-menu) .dropdown-menu.show');
        if (!hasHoveredDropdown && !hasOpenClickDropdown) {
          body.classList.remove('nav-open');
        }
      });
    } else {
      // For click dropdowns (Bootstrap events)
      const dropdowns = navbarNav.querySelectorAll('.dropdown:not(.has-mega-menu)');

      dropdowns.forEach(dropdown => {
        // Add nav-open when dropdown shows (only if overlay enabled and on desktop)
        dropdown.addEventListener('show.bs.dropdown', (e) => {
          // Check if this event is actually for this dropdown, not a bubbled event from a child
          const targetDropdown = e.target.closest('.dropdown');
          if (targetDropdown !== dropdown) {
            return;
          }

          if (hasOverlay && isDesktopBreakpoint(navbar)) {
            body.classList.add('nav-open');
          }
        });

        // Remove nav-open when all dropdowns are hidden
        dropdown.addEventListener('hidden.bs.dropdown', (e) => {
          // Check if this event is actually for this dropdown, not a bubbled event from a child
          const targetDropdown = e.target.closest('.dropdown');
          if (targetDropdown !== dropdown) {
            return;
          }
          // Only check for non-mega-menu dropdowns
          const hasOpenDropdown = document.querySelector('.navbar-nav .dropdown:not(.has-mega-menu) .dropdown-menu.show');
          if (!hasOpenDropdown) {
            body.classList.remove('nav-open');
          }
        });
      });
    }
  });
};

// Override default Bootstrap menu behavior
const hoverDropdown = () => {

  // Get All Siblings
  const getSiblings = function (e) {
    // for collecting siblings
    const siblings = [];
    // if no parent, return no sibling
    if(!e.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling  = e.parentNode.firstChild;

    // collecting siblings
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
  };

  // Close All Menus
  const hideAllMenus = () => {
    const openNavMenus = [].slice.call( document.querySelectorAll('.dropdown-hover .dropdown-menu.show') );
    const openNavLinks = [].slice.call( document.querySelectorAll('.dropdown-hover .dropdown-toggle[aria-expanded="true"]') );
    if (openNavMenus.length) {
      openNavMenus.forEach(menu => {
        menu.classList.remove('show');
      });
    }
    if (openNavLinks.length) {
      openNavLinks.forEach(link => {
        link.setAttribute('aria-expanded', 'false');
        link.classList.remove('show');
      });
    }
  };

  // Toggle dropdown menus
  const dropdowns = [].slice.call( document.getElementsByClassName('dropdown-hover') );
  if (dropdowns.length) {
    dropdowns.forEach(dropdown => {

      const links = [].slice.call( dropdown.getElementsByClassName('dropdown-toggle') );
      if (links !== null) {
        links.forEach(link => {
          const linkCaret = link.querySelector('.caret');
          const linkSiblings = getSiblings(link.parentNode);
          // const linkDropdown = link.parentElement;
          // const linkMenu = linkDropdown.querySelector('.dropdown-menu');
          // const linkOpenMenus = [].slice.call(linkDropdown.parentElement.getElementsByClassName('show'));
          // const linkOpenMenuToggles = linkDropdown.parentElement.querySelectorAll('.dropdown-toggle[aria-expanded="true"]');
          // const showMenu = () => {
          //   link.setAttribute('aria-expanded', 'true');
          //   link.classList.add('show');
          //   linkMenu.classList.add('show');
          // };
          // const hideMenu = () => {
          //   link.setAttribute('aria-expanded', 'false');
          //   link.classList.remove('show');
          //   linkMenu.classList.remove('show');
          // };
          // const toggleMenu = () => {
          //   if (linkMenu.classList.contains('show')) {
          //     // hideMenu();
          //     $(link).dropdown('hide');
          //   } else {
          //     // showMenu();
          //     // hideAllMenus();
          //     $(link).dropdown('show');
          //   }
          // };
          // const hideOpenMenus = () => {
          //   console.log(linkOpenMenus);
          //   if (linkOpenMenus.length) {
          //     linkOpenMenus.forEach(menu => {
          //       menu.classList.remove('show');
          //     });
          //   }
          // };
          const hideOpenMenus = () => {
            if (linkSiblings.length > 0) {
              linkSiblings.forEach(sibling => {
                const siblingLink = sibling.querySelector('.dropdown-toggle');
                $(siblingLink).dropdown('hide');
              });
            }
          };

          link.addEventListener('click', e => {
            // Stop clicks inside a dropdown menu from toggling dropdown
            e.stopPropagation();
            e.stopImmediatePropagation();
            hideOpenMenus();

            // Enable link
            const url = link.getAttribute('href');
            window.location = url;
          });

          if (linkCaret !== null) {
            linkCaret.addEventListener('click', e => {
              // Prevent caret from activating link
              e.preventDefault();
              e.stopImmediatePropagation();

              // Hide open menus
              hideOpenMenus();

              // Toggle dropdown when caret clicked
              // toggleMenu();
              // $(link).dropdown('toggle');
            });
          }

        });
      }

    });
  }

  // Close Menus on click outside
  const {body} = document;
  body.addEventListener('click', () => {
    hideAllMenus();
  });

  // Close Menus when window resized
  // eslint-disable-next-line @wordpress/no-global-event-listener
  window.addEventListener('resize', () => {
    hideAllMenus();
  });
};

// const closeNav = () => {
//   const nav = $('#siteNav');
//
//   $('body').on('click', () => {
//     if ($(nav).hasClass('show')) {
//       $(nav).collapse('hide');
//     }
//   });
//
//   $(nav).on('click', e => {
//     e.stopPropagation();
//   });
// };

// Close menus for click behavior
const closeClickMenus = () => {
 // Only apply to navbars with .toggle-open-menus class
 const navbars = document.querySelectorAll('.navbar-nav.toggle-open-menus');


 navbars.forEach(navbar => {
   // Skip if this is a hover dropdown navbar
   if (navbar.classList.contains('dropdown-hover')) {
     return;
   }


   // Only process top-level dropdowns to avoid nested dropdown issues
   const dropdowns = navbar.querySelectorAll(':scope > li.dropdown, :scope > ul > li.dropdown, :scope > ol > li.dropdown, :scope > div > li.dropdown');


   dropdowns.forEach(dropdown => {
     // When a dropdown is about to show
     dropdown.addEventListener('show.bs.dropdown', (e) => {
       // Check if this event is actually for this dropdown, not a bubbled event from a child
       const targetDropdown = e.target.closest('.dropdown');
       if (targetDropdown !== dropdown) {
         return;
       }

       // Find all other top-level dropdowns in this navbar
       const otherDropdowns = navbar.querySelectorAll(':scope > li.dropdown, :scope > ul > li.dropdown, :scope > ol > li.dropdown, :scope > div > li.dropdown');


       otherDropdowns.forEach(otherDropdown => {
         // Skip the current dropdown that's opening
         if (otherDropdown === dropdown) {
           return;
         }

         // Skip if this is a parent or child of the current dropdown
         if (dropdown.contains(otherDropdown) || otherDropdown.contains(dropdown)) {
           return;
         }


         // Close any other open dropdown (only at the same level)
         const otherToggle = otherDropdown.querySelector(':scope > .dropdown-toggle');
         if (otherToggle && otherToggle.getAttribute('aria-expanded') === 'true') {
           $(otherToggle).dropdown('hide');
         }
       });
     });
   });
 });
};

// Prevent nested dropdowns from closing parent dropdowns on mobile
const preventParentClose = () => {
  // Stop propagation on nested dropdown toggle clicks to prevent parent from closing
  const nestedToggles = document.querySelectorAll('.dropdown-menu .dropdown-toggle');

  nestedToggles.forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
    }, true); // Use capture phase to intercept before Bootstrap
  });

  // Also stop propagation on the nested dropdown menus themselves
  const nestedMenus = document.querySelectorAll('.dropdown-menu .dropdown-menu');
  nestedMenus.forEach(menu => {
    menu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
};

/**
 * ========================================
 * Mega Menu 
 * ========================================
 */

// Position relative mega menus to align with left edge of viewport
const positionRelativeMegaMenus = () => {
  $('.navbar-nav.nav-item-relative-mega-menu .nav-item.has-mega-menu, .content-wrapper .nav-item.has-mega-menu').each(function() {
    const $item = $(this);
    const $dropdown = $item.find('.mega-menu-dropdown');

    // Find the parent navbar and get its desktop breakpoint
    const navbar = $item.closest('.navbar')[0];

    // Only apply transform on desktop (above navbar's expand breakpoint)
    if (isDesktopBreakpoint(navbar)) {
      // Get nav item's left position relative to viewport
      const itemRect = $item[0].getBoundingClientRect();
      const offsetLeft = itemRect.left;

      // Apply negative transform to align dropdown with left edge of viewport
      $dropdown.css('transform', `translateX(-${offsetLeft}px)`).css('width', '100vw');
    } else {
      // Reset transform on mobile
      $dropdown.css('transform', '');
    }
  });
};

const preventMegaMenuClose = () => {
  const megamenus = [].slice.call(document.querySelectorAll('.nav-item.has-mega-menu .mega-menu-dropdown'));

  megamenus.forEach(menu => {
    if (menu !== null) {
      menu.addEventListener('click', (e) => { 
        e.stopImmediatePropagation();
      });
    }
  })
};

const megaMenu = () => {
  // Find all navbars
  const $navbars = $('.navbar-nav');

  // Bail if no navbars exist
  if (!$navbars.length) {
    return;
  }

  const $body = $('body');

  // Handle each navbar individually
  $navbars.each(function() {
    const $nav = $(this);

    // Check if THIS specific navbar has mega menu items
    if (!$nav.find('.nav-item.has-mega-menu').length) {
      return;
    }

    // Only navbars with .has-overlay should trigger body overlay classes
    const hasOverlay = $nav.hasClass('has-overlay');
    // Find parent .navbar element for breakpoint detection
    const navbar = $nav.closest('.navbar')[0];

    // Handle hover dropdowns (CSS-controlled)
    if ($nav.hasClass('dropdown-hover')) {
      $nav.on('mouseenter', '.nav-item.has-mega-menu', function() {
        if (hasOverlay && isDesktopBreakpoint(navbar)) {
          $body.addClass('mega-menu-open');
        }
        // Position mega menus on hover to prevent jump
        positionRelativeMegaMenus();
      });

      $nav.on('mouseleave', '.nav-item.has-mega-menu', function() {
        // Only handle removal on desktop - mobile nav manages its own state
        if (!isDesktopBreakpoint(navbar)) {
          return;
        }
        // Check if any mega menus in THIS navbar are still being hovered
        if (!$nav.find('.nav-item.has-mega-menu:hover').length) {
          $body.removeClass('mega-menu-open');
        }
      });
    }
    // Handle click dropdowns (Bootstrap-controlled)
    else {
      $nav.on('show.bs.dropdown', '.nav-item.has-mega-menu', function() {
        if (hasOverlay && isDesktopBreakpoint(navbar)) {
          $body.addClass('mega-menu-open');
        }
        // Position mega menus BEFORE showing to prevent jump
        positionRelativeMegaMenus();
      });

      $nav.on('shown.bs.dropdown', '.nav-item.has-mega-menu', function() {
        const $item = $(this);
        const $dropdown = $item.find('.mega-menu-dropdown');

        // Set focus to first focusable element (accessibility)
        const $firstFocusable = $dropdown.find('a, button, input, [tabindex]:not([tabindex="-1"])').first();
        if ($firstFocusable.length) {
          $firstFocusable.focus();
        }
      });

      $nav.on('hide.bs.dropdown', '.nav-item.has-mega-menu', function() {
        // Only handle removal on desktop - mobile nav manages its own state
        if (!isDesktopBreakpoint(navbar)) {
          return;
        }
        $body.removeClass('mega-menu-open');
      });

      $nav.on('hidden.bs.dropdown', '.nav-item.has-mega-menu', function() {
        // Return focus to trigger (accessibility)
        $(this).find('> .nav-link').focus();
      });
    }
  });

  preventMegaMenuClose();
  
  positionRelativeMegaMenus();

  // eslint-disable-next-line @wordpress/no-global-event-listener
  $(window).on('resize', function() {
    positionRelativeMegaMenus();
  });
};

$(document).ready(() => {
  navEnable();
  // dropdownHover();
  hoverDropdown();
  // closeNav();
  closeClickMenus();
  megaMenu();
  handleNavOpenClass();
  preventParentClose();
});

export default navEnable;